export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex flex-col bg-background-50">
      <div className="flex-1 flex items-center">
        <div className="w-full max-w-[1440px] mx-auto px-8 md:px-16 pt-20 md:pt-28 pb-12">
          <div className="flex flex-col lg:flex-row lg:items-start gap-0">
            <div className="w-full lg:w-1/2">
              <h1 className="text-[88px] md:text-[100px] font-extrabold leading-[0.92] tracking-[-0.02em] text-foreground-950 font-heading">
                Spinne<br />Traffic d.o.o.
              </h1>
            </div>

            <div className="w-full lg:w-1/2 pt-6 lg:pt-4">
              <p className="text-lg md:text-xl font-medium text-foreground-600 leading-relaxed max-w-[480px]">
                A professional engineering team focused on designing and developing modern digital software solutions for the iOS platform and related technologies.
              </p>
              <div className="mt-8 w-10 h-[2px] bg-foreground-800"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full max-w-[1440px] mx-auto px-8 md:px-16 pb-16 md:pb-24">
        <div className="w-full h-[360px] md:h-[440px] rounded-[22px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20dark%20minimalist%20architectural%20composition%20with%20clean%20geometric%20lines%20and%20soft%20diffused%20lighting%2C%20warm%20amber%20and%20charcoal%20tones%2C%20textured%20concrete%20and%20steel%20surfaces%2C%20no%20people%2C%20no%20text%2C%20no%20logos%2C%20atmospheric%20and%20contemplative%20mood%2C%20fine%20art%20architectural%20photography%20style%20with%20subtle%20film%20grain%2C%20dark%20shadow%20areas%20contrasting%20with%20soft%20highlights&width=1600&height=600&seq=hero-engineering-01&orientation=landscape"
            alt="Engineering architecture and design"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}